<template>
  <span
    v-tooltip.top="t('Notificações ao franqueado chegam em breve')"
    data-testid="notify-owner-stub-wrapper"
  >
    <!-- D7: notifications DEFERRED — this button is intentionally inert (console.log stub only) -->
    <Button
      data-testid="notify-owner-stub-btn"
      :label="t('Notificar franqueado')"
      icon="pi pi-bell"
      severity="secondary"
      :disabled="true"
      @click="onStubClick"
    />
  </span>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { log } from '../../utils/DebugLogger'

const { t } = useI18n()

/**
 * D7: Notifications are DEFERRED. This is an intentionally inert stub.
 * No real notification is sent. Replace when the notification system lands.
 */
function onStubClick(): void {
  // D7 deferred-notifications stub — no real action performed.
  log('NotifyOwnerStub', 'onStubClick', 'D7: notificações ao franqueado estão adiadas — stub inerte')
}
</script>
